import styled from "styled-components";
import { PrivacyPolicyBackground } from "./PrivacyPolicyBackground";
import { PrivacyPolicyContents } from "./PrivacyPolicyContents";
import { MainFooter } from "../../Footer/MainFooter";

export function ComponentPrivacyPolicy() {
	return (
		<HomepageContainer>
			<PrivacyPolicyBackground />
			<BodyContainer>
				<PrivacyPolicyContents />
			</BodyContainer>
			<footer style={{ width: "100%" }}>
				<MainFooter />
			</footer>
		</HomepageContainer>
	);
}

const HomepageContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
const BodyContainer = styled.div`
	max-width: 1442px;
	padding: clamp(16px, 4vw, 50px) clamp(16px, 4vw, 136px);
	width: 100%;
`;
